<template>
    <div class="spo-card rounded bordered p-2 my-3">
        <div class="text-h6 font-weight-bold">Liste des liens de groupe</div>
        <v-table density="compact" v-if="list_liens.length > 0">
            <thead>
                <tr>
                    <th class="text-left">Statut</th>
                    <th class="text-left">Nom groupe</th>
                    <th class="text-left">Limitation</th>
                    <th class="text-left">Utilisation</th>
                    <th class="text-left">Suivi</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in list_liens" :key="item.id">
                    <td>
                        <v-chip :color="getStatutColor(getStatutLabel(item))" density="compact" variant="elevated"
                            elevation="0">{{ getStatutLabel(item) }} {{ info_paiement(item) }}</v-chip>
                    </td>
                    <td>{{ item.nom }}</td>
                    <td>{{ item.max_inscrits == 0 ? 'Aucune limite' : item.max_inscrits + ' inscriptions' }}</td>
                    <td>{{ item.nb_inscrits }} inscription<span v-if="item.nb_inscrits > 1">s</span> (sur {{
                        item.nb_commandes }} commande<span v-if="item.nb_commandes > 1">s</span>)</td>
                    <td>
                        <SportipsButton @onClick="navigateToSuivi(item.token)" icon="mdi-chart-timeline-variant"
                            color="primary" variant="text" size="small">
                            Suivi du groupe
                        </SportipsButton>
                    </td>
                </tr>
            </tbody>
        </v-table>

        <v-alert v-else variant="tonal" color="info">Aucun lien de groupe pour ce module</v-alert>

    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";
export default {
    data() {
        return {
            list_liens: [],
        };
    },
    computed: {
        ...mapStores(useMainStore),

    },
    methods: {
        navigateToSuivi(token) {
            this.$router.push({ name: 'SuiviLienGroupe', params: { base_module: this.mainStore.module.base, token: token } });
        },
        info_paiement(item) {
            let info = '';
            if (item.statut_paiement !== 'PAID') return '';

            if (item.total_responsable_with_tax > 0) info += item.total_responsable_with_tax + '€';
            if (item.type_paiement && item.type_paiement !== 'aucun') info += ' par ' + item.type_paiement;
            if (info.length > 0) {
                info = '(' + info + ')';
            }
            return info;
        },
        getStatutLabel(item) {
            if (item.statut_paiement === 'PAID' && item.total_responsable == 0) return 'Cloturé';
            if (item.statut_paiement === 'PAID' && item.total_responsable > 0) return 'Payé';
            if (item.statut_paiement === 'UNPAID' && item.total_responsable > 0) return 'En attente de paiement';
            if (item.disable === '1') return 'Cloturé';
            return 'Actif';
        },
        getStatutColor(statut) {
            const colors = {
                'Actif': 'green',
                'En attente de paiement': 'primary-dark',
                'Payé': 'secondary-dark',
                'Cloturé': 'secondary-dark',
            };
            return colors[statut] || 'grey';
        },
        async loadLiens() {
            const request = await AdminService.getLiensGroupe(this.mainStore.module.id);
            if (request) {
                this.list_liens = request;
            }
        }

    },

    async created() {
        await this.loadLiens();
    },

}
</script>

<style lang="scss" scoped></style>
